import React from 'react'
import '../App.css'
import Bodyhomeadminsustituciones from './bodyhomeadminsustituciones'
export class Bodyapphomebodyadminsustituciones extends React.Component {
    state = {
    }
    render() {       
        return (
            <div className='sshbodyapp'>
                <div className='sshbodyappContainer'>
                    <Bodyhomeadminsustituciones />
                </div>
            </div>
        );
    }
}